import GongqiFormItemControl from './GongqiFormItemControl';
import CmdTypeActions from '../../actions/CmdTypeActions';
import ControlPropertyConst from '../controlproperty/ControlPropertyConst';

export default class FormItemContainerControl extends GongqiFormItemControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemContainerControl";
	}

	getProperty_Layout()
	{
		var _parentWindow = window.parent.window;
		if(!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			let _properties = _userProperties[this.xml.id];
			if(_properties && _properties.hasOwnProperty("layout"))
				return _properties["layout"];
		}
		return this.xml.Properties.Layout.Value;
	}

	setControlProperty(property,value)
	{
		if(property == ControlPropertyConst.HASBORDER)
		{
			this.propertyHasBorder = value;
			this.hasBorderSetted = true;
			CmdTypeActions.updateControlProperty(this.xml.name,property,value,this.module.instanceUUId);
		}
	}

	getFlexGrow100()
	{
		if(this.classAlias == "FormItemGroupControl" && !window.formHasDataGrid)
		{
			let parent = this.parentControl.xml;
			if(parent.id == "FormDesign")
			{
				let children = this.parentControl.childrenControl;
				if(children && children.indexOf(this) == children.length-1)
					return true;
			}
		}
		
		return false;
	}

	getStyle()
	{
		let layout = this.getProperty_Layout();//this.xml.Properties.Layout.Value;
		let parentLayout = this.parentControl.getProperty_Layout();//this.parentXML.Properties.Layout.Value;
		let flexDirection = (layout=="horizontal"?"row":"column");
		let style = {
		  display:"flex",
		  flex:'none'
		  //alignSelf:"stretch"
		  //overflow:'auto'
		};
		if(this.parentControl && this.parentControl.classAlias == "FormItemDesignControl")
			style.alignSelf = "stretch";
	    style["flexDirection"] = flexDirection;
	    style["alignItems"] = "flex-start";
	    let _containsMaxControl = this.containsMaxControl(this.xml,this.getProperty_Layout());
	    //TODO由于某些情况 不能加入overflow为auto 但是去掉会导致某些分辨率低的情况页面超出 猜想是包含最大化控件的时候不能
	    //加入 先加入留待后续观察
	    if(!_containsMaxControl)
	    	style.overflow = 'auto';
	    if(parentLayout == "horizontal")
	    {
	    	//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
	    	//alert(json);
			let _width = this.getProperty_Width();//this.xml.Properties.Width.Value;
	    	if(_width == undefined || _width == 0)
				_width = "";
			if(typeof(_width) == "number")_width=_width+"";
			let flexGrow = 0;
			let fixedWidth = false;
			let _containsMaxControl = this.containsMaxControlForWidth(this.xml);
			let _isFlexGrow = this.getFlexGrow100();
			if(_width == "" && !window.isPopUp && !window.isLookup && (_containsMaxControl || _isFlexGrow))
			{
				flexGrow = 100;
			}
			else
			{
				let iex = _width.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _width.substring(0,iex);
					style.width = _width;
				}
				
				if(iex==-1&&_width != "")
				{
					flexGrow = _width+"px";
					fixedWidth = true;
				}	
			}
			
			if(!fixedWidth)style["flexGrow"] = flexGrow;
			else style["width"] = flexGrow;

			let _height = this.getProperty_Height();//this.xml.Properties.Height.Value;
			if(_height == undefined || _height == 0)
				_height = "";
			if(_height == "" && !window.isPopUp && !window.isLookup)
			{
				 let _containsMaxControl = this.containsMaxControlForHeight(this.xml);
				 if(_containsMaxControl)_height = "100%";
			}
			if(_height == "100%")
				style["alignSelf"] = "stretch";
			else if(_height.indexOf("%") != -1)
				style["height"] = _height;
			else if(_height != "")
				style["height"] = _height+"px";
	    }
	    else //vertical 暂不考虑absolute
	    {
	    	let _height = this.getProperty_Height();//this.xml.Properties.Height.Value;
	    	if(_height==undefined || _height == 0)
				_height = "";
			if(typeof(_height) == "number")_height=_height+"";
			let flexGrow = 0;
			let fixedHeight = false;
			if(_height == "" && !window.isPopUp && !window.isLookup)
			{
				let _isFlexGrow = this.getFlexGrow100();
				if(_isFlexGrow)
					flexGrow = 100;
				else
				{
					let _containsMaxControl = this.containsMaxControlForHeight(this.xml);
					if(_containsMaxControl)flexGrow = 100;
				}
				
			}
			else
			{
				let iex = _height.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _height.substring(0,iex);
					style.height = _height;
				}
				if(iex==-1&&_height != "")
				{
					flexGrow = _height+"px";
					fixedHeight = true;
				}	
			}
			
			if(!fixedHeight)style["flexGrow"] = flexGrow;
			else style["height"] = flexGrow; 

			let _width = this.getProperty_Width();//this.xml.Properties.Width.Value;
			if(_width == undefined)
				_width = "";
			if(_width == "" && !window.isPopUp && !window.isLookup)
			{
				 let _containsMaxControl = this.containsMaxControlForWidth(this.xml);
				 if(_containsMaxControl)_width = "100%";
			}
			if(_width == "100%")
				style["alignSelf"] = "stretch";
			else if(_width.indexOf("%") != -1)
				style["width"] = _width;
			else if(_width != "")
				style["width"] = _width+"px";
	    }
		let _superStyle = super.getStyle();
		if(_superStyle)
		{
			Object.assign(style,_superStyle);
		}
		return style;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemContainerControl.js